import { render, staticRenderFns } from "./LandingChristmasIT.vue?vue&type=template&id=43c98a06&scoped=true"
import script from "./LandingChristmasIT.vue?vue&type=script&lang=js"
export * from "./LandingChristmasIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c98a06",
  null
  
)

export default component.exports